import {
  Box,
  CssBaseline,
  Drawer,
  ThemeProvider,
} from "@mui/material";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import AllRoutes from "navigation";
import { useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideMenu from "shared-component/side-menu";
import TopAppBar from "shared-component/top-app-bar";
import LoginErrorPage from "pages/login/LoginError";
import LoginPage from "pages/login/Login";
import { useNavigate } from "react-router-dom";
import { lightTheme } from "theme/theme";

dayjs.extend(utc);
dayjs.extend(timezone);

const drawerWidth = 250;

export default function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const mainRef = useRef(null);
  const navigate = useNavigate();
  // user selector of userData, redux
  // Drawer action
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container = mainRef ? () => mainRef?.current : undefined;

  const handleLogout = async () => {
    sessionStorage.clear();
    setTimeout(() => {
      navigate('/')
    }, 500)
  };


  const requestAccess = () => {
    window.open('https://www.ascentt.com/', '_blank');
  };

  const triggerLogin = () => {
    console.log('login')
  }
  const userInfo = sessionStorage.getItem('userInfo');
  console.log('userInfo', userInfo)
  return (
    <>
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      {window.location.pathname === '/' && userInfo === null ? <LoginPage triggerLogin={triggerLogin} requestAccess={requestAccess} />
        : window.location.pathname === '/login-error' && userInfo === null ? <LoginErrorPage triggerLogin={triggerLogin} requestAccess={requestAccess} />
          :
          <>
            <Box sx={{ display: "flex" }} id={"screen"}>
              <TopAppBar
                handleDrawerToggle={handleDrawerToggle}
                logout={async () => {
                  handleLogout();
                }}
                userInfo={userInfo && JSON.parse(userInfo)}
              />
              <div
                onMouseEnter={handleDrawerToggle}
                style={{
                  position: 'fixed',
                  left: 0,
                  top: 0,
                  width: '25px', // Width of the hover area
                  height: '100vh',
                  cursor: 'pointer', // Change cursor to indicate hoverable area
                }}
              />
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
              >
                <SideMenu handleDrawerToggle={handleDrawerToggle} />
              </Drawer>
              <Box
                ref={mainRef}
                sx={{
                  width: {
                    md: `100%`,
                    sm: "100%",
                    xs: "100%",
                  },
                  maxHeight: `calc(100vh - 64px)`,
                  height: `calc(100vh - 64px)`,
                  minHeight: `calc(100vh - 64px)`,
                  padding: "2%",
                  marginTop: "64px",
                  overflowY: "auto",
                  background: "linear-gradient(180deg, #ff6c30 35%, #f0f0f0 20%)",
                  backgroundImage: window.location.pathname === "/canva" ? "" : "url(https://www.ascentt.com/wp-content/uploads/2023/01/banner-2.jpg)"
                }}
              >
                <AllRoutes />
              </Box>
              <ToastContainer
                position="bottom-left"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={true}
                limit={3}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                pauseOnHover
                theme={"colored"}
              />
            </Box>
          </>
      }
      </ThemeProvider>
    </>
  );
}


